import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
import { useSelector } from 'react-redux';
import styled from 'styled-components';
import FormattedMessage from 'I18n/components/FormattedMessage';
import { FREE } from 'self-service-api/constants/ProductLevels';
import { isAppAuthSelector } from '../../selectors/AuthSelectors';
import { hasPricingAndPurchasingSucceededSelector } from '../../selectors/LoadingStateSelectors';
import SkeletonLoadWrapper from '../common/loading/SkeletonLoadWrapper';
import SignupButton from '../common/SignupButton';
import { CrmSuitePrice } from '../merch-card/price-display/CrmSuitePrice';
const TableHeaderCell = styled.th.withConfig({
  displayName: "SuiteFeatureTableHeaderCell__TableHeaderCell",
  componentId: "n6p3zt-0"
})(["text-align:center;font-weight:normal;"]);

const SuiteFeatureTableHeaderCell = ({
  productLevel
}) => {
  const isInApp = useSelector(isAppAuthSelector);
  const hasPricingAndPurchasingSucceeded = useSelector(hasPricingAndPurchasingSucceededSelector);
  return /*#__PURE__*/_jsxs(TableHeaderCell, {
    children: [/*#__PURE__*/_jsx("strong", {
      children: /*#__PURE__*/_jsx(FormattedMessage, {
        message: `products.crm.${productLevel}`
      })
    }), /*#__PURE__*/_jsx("br", {}), productLevel === FREE ? !isInApp && /*#__PURE__*/_jsx(SignupButton, {
      sourceId: "suite-feature-table",
      use: "link",
      productLine: "crm"
    }) : /*#__PURE__*/_jsx(SkeletonLoadWrapper, {
      isLoading: !hasPricingAndPurchasingSucceeded,
      heights: [19],
      widths: [190],
      className: "flex-column",
      Content: CrmSuitePrice,
      contentProps: {
        productLevel,
        concise: true,
        wrapperStyle: {
          textAlign: 'center'
        }
      }
    })]
  });
};

export default SuiteFeatureTableHeaderCell;